<template>
  <v-container>
    <v-row justify="center">
      <v-col>
        <div id="firebaseui-auth-container" class="xs12"></div>
        <v-row justify="center">
          <div>
            {{ environment }} ----------
            {{ firebase_app }}
          </div>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import firebaseAuth from 'firebase/compat/app'
import * as firebaseui from 'firebaseui'
import 'firebaseui/dist/firebaseui.css';

export default {
  name: "LoginView",
  data() {
    return {
      environment: '',
      firebase_app: '',
    }
  },
  async created() {
    console.log('HERE')
    const { user } = this.$store.getters
    // if (user) this.$router.push('/dashboard', () => {})

    await firebaseAuth.auth().signOut()

    const uiConfig = {
      signInSuccessUrl: '/processing',
      signInOptions: [
        firebaseAuth.auth.GoogleAuthProvider.PROVIDER_ID,
        firebaseAuth.auth.EmailAuthProvider.PROVIDER_ID,
      ],
    };

    // console.log(firebase.auth())
    if (firebaseAuth) {
      const ui = new firebaseui.auth.AuthUI(firebaseAuth.auth());
      ui.start('#firebaseui-auth-container', uiConfig);
    }

    this.environment = process.env.NODE_ENV
    console.log(firebaseAuth.app().firestore().app)
    this.firebase_app = firebaseAuth.app.projectId || 'unknown'
  }
}
</script>

<style scoped>

</style>